// ============================================================
// CONTRACT ADDRESSES - Update after deployment
// ============================================================

const ADDRESSES = {
  testnet: {
    USDT: '0xBf6596a279172D330b8b732D257Ee633B6FDA911',
    UVW_Core: '0x670bEb97b82C265636D98D8143a35D8a31B430b1',
    UVW_Matrix: '0x36835C3c34e088F7AC646D4d4aF4836aE6EcdF7B',
    UVW_Pools: '0x952194431A59BF57E83E41E95BA1b09946285D89',
    UVW_Views: '0x35b0fe7c6A8BE0879514e25258aE1c1238B9AD70'
  },
  mainnet: {
    USDT: '0x9e5aac1ba1a2e6aed6b32689dfcf62a509ca96f3',
    UVW_Core: '0x34F79203E5b960B271C816f7eE17AABb14D37a6B',
    UVW_Matrix: '0x2539D48C02Ba4a9A7Ba9B84C8FD195215ca0EbC4',
    UVW_Pools: '0x9D77D1aFa8088F0D83F7Ea4d6451b806E6c16193',
    UVW_Views: '0x32b7445564CE1A835Fe6806C16541953b2947108'
  }
};

// This reads from network.js config
const ACTIVE_NETWORK = 'mainnet'; // Must match network.js

export const CONTRACT_ADDRESSES = ADDRESSES[ACTIVE_NETWORK];
export default CONTRACT_ADDRESSES;
